/** Sentinel item id for the "no channel" row of the channel quick filter. Never leaks into a URL. */
export const DONATION_SOURCE_NONE = "__none__";
/** Every URL param that expresses a filter/view selection on /donations. */
export const DONATION_LIST_URL_FILTER_PARAMS = [
    "view",
    "status",
    "type",
    "method",
    "campaignId",
    "donationSource",
    "withoutDonationSource",
];
function inValues(filters, key) {
    const f = filters[key];
    return f?.type === "in" ? f.values : [];
}
export function serializeDonationSourceFilter(values) {
    const channels = values.filter((v) => v !== DONATION_SOURCE_NONE);
    return {
        donationSource: channels.length > 0 ? channels.join(",") : undefined,
        withoutDonationSource: values.includes(DONATION_SOURCE_NONE) ? "true" : undefined,
    };
}
export function deserializeDonationSourceFilter(query) {
    const raw = query.donationSource;
    const csv = typeof raw === "string" && raw.length > 0 ? raw : Array.isArray(raw) ? raw[0] : null;
    const values = csv ? String(csv).split(",") : [];
    if (query.withoutDonationSource === "true")
        values.push(DONATION_SOURCE_NONE);
    return values;
}
/**
 * `?campaignId=` -> a 0-or-1-element filter value. `mapFiltersToSearchParams` only ever sends
 * `values[0]` to the backend, so a `?campaignId=a,b` URL must clamp to the FIRST id — otherwise
 * the pill hydrates as a 2-value selection while the request carries only "a".
 */
export function deserializeCampaignIdFilter(query) {
    const raw = query.campaignId;
    const csv = typeof raw === "string" && raw.length > 0 ? raw : Array.isArray(raw) ? raw[0] : null;
    const first = csv ? String(csv).split(",")[0] : "";
    return first ? [first] : [];
}
/** True when the URL explicitly selects a view or any filter — the persisted active tab must not override it. */
export function hasUrlListSelection(query) {
    return DONATION_LIST_URL_FILTER_PARAMS.some((p) => {
        const v = query[p];
        return typeof v === "string" ? v.length > 0 : Array.isArray(v) && v.length > 0;
    });
}
/** Table filter state -> DonationSearchParams subset for store.loadDonations. */
export function mapFiltersToSearchParams(filters) {
    const sourceValues = inValues(filters, "donationSource");
    const channels = sourceValues.filter((v) => v !== DONATION_SOURCE_NONE);
    const statuses = inValues(filters, "status");
    const donationTypes = inValues(filters, "donationType");
    const paymentMethods = inValues(filters, "paymentMethod");
    const campaignValues = inValues(filters, "campaignId");
    return {
        ...(statuses.length > 0 && { statuses: statuses }),
        ...(donationTypes.length > 0 && { donationTypes: donationTypes }),
        ...(paymentMethods.length > 0 && { paymentMethods: paymentMethods }),
        ...(sourceValues.length > 0 && {
            sources: channels.length > 0 ? channels : undefined,
            withoutSource: sourceValues.includes(DONATION_SOURCE_NONE) ? true : undefined,
        }),
        ...(campaignValues.length > 0 && { campaignId: campaignValues[0] }),
    };
}
